export default class Rating {
  constructor(container) {
    this._max = 5
    this._contaier = document.querySelectorAll(container)
    this.init()
  }

  init() {
    if (this._contaier.length) {
      this._contaier.forEach(container => {
        const rating = container.getAttribute('data-rating')

        if (container) container.querySelector('.stars-current').style.width = `${this.calcWidth(rating)}%`
        if (!container) console.warn('.stars-current not exist')
      })
    }
  }

  calcWidth(rating) {
    return (rating / this._max) * 100
  }
}
